var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.appReady)?_c('router-view'):_c('SplashScreen')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }